module.exports = __webpack_public_path__ + "media/images/banners/4-c493edc98a2962c587049d01e305e192.png";